import {Category,UtilLibs} from '@digital-supply-chain/module'
import { ApiService, DataService } from "../service";

let viewOptions: any = [];
let OrgList: any = null;
export const rangeEnum: any = {
    0: "无权限",
    1: "自己的",
    2: "本部门",
    3: "本部门及下级部门",
    4: "全公司"
};

export const CategoryDir: Array<number> = [
	Category.DrawingDir,
	Category.DocumentDir,
	Category.EnterpriseDir,
	Category.EnterpriseShare,
	Category.OutSourceDir,
	Category.OutSourceDirShare,
  ]

export class AuthService {
	//获取当前用户数据
	static user() {
		let userInfo = {};
		try {
			userInfo = (window as any).md.getLoginInfo();
		} catch (error) {}
		return AuthService.userTransition(userInfo) || {};
	}

	static userTransition(user: any) {
		for (var key in user) {
			user[key.substring(0, 1).toUpperCase() + key.substring(1)] = user[key];
		}
		user.UserID = user.UserId || user.UserID;
		user.CompID = user.CompanyId || user.CompID || user.CompId || user.compID;
		user.CompName = user.CompanyName || user.CompName;
		user.CompMdt = user.CompanyMdt || user.CompMdt;
		user.CompLogo = user.CompanyLogo || user.compLogo;
		user.CompVipLevel = user.CompanyVipLevel || user.compVipLevel;
		user.OrgID = user.OrgId || user.OrgID;
		return user;
	}

	//获取当前登陆用户token
	static token(bearer = true): any {
		//暂增加在storge中获取token
		let user: any = AuthService.user();
		let token = user && (user.token || user.Token);
		return `${bearer ? "Bearer " : ""}` + token;
	}

	// 根据企业id获取是否有分类选型展示
	static getLectoByCompid(CompID: string) {
		return ["51507", "24852"].includes(`${CompID}`);
	}


	// 权限授权相关
	static getAuthCols(isData: Boolean, categoryId: any) {
		let getviewOptions = () => {
		  if (viewOptions.length > 0) return viewOptions;
		  Object.keys(rangeEnum).forEach(key => {
			viewOptions.push({
			  label: rangeEnum[key],
			  value: Number(key)
			});
		  });
		  return viewOptions;
		};
		let ViewSelect = {
		  prop: "view",
		  label: "查看范围",
		  component: "select",
		  align: "left",
		  options: getviewOptions(),
		  width: "160",
		  default: 4
		};
		let View = {prop: "view", label: "查看", component: "checkbox", disabled: true, width: "50", default: 4};
		let Download = {prop: "download", label: "下载", component: "checkbox", width: "50", default: 1};
		let Add = {prop: "add", label: "新建", component: "checkbox", width: "50", default: -1};
		let Edit = {prop: "edit", label: "修改", component: "checkbox", width: "50", default: -1};
		let Delete = {prop: "del", label: "管理", component: "checkbox", width: "50", default: -1};
		// let ExpiryDate = {prop: "ExpiryDate", label: "有效期至", component: "datePicker", width: "100", default: "2099-12-31"};
	
		let category = Number(categoryId);
		if (isData) {
		  switch (true) {
			  // 供应链
			case [Category.OutSource, Category.Enterprise].includes(category):
			  return [View, Edit, Delete];
			  // 目录
			case CategoryDir.includes(category):
			  Add.label = "写入"
			  return [View, Add, Delete];
			  // 其他数据
			default:
			  return [View, Download, Edit,  Delete]; // 
		  }
		} else {
		  // 类目/目录 授权
		  Download.default = -1;
		  switch (true) {
			  // 供应链
			case [Category.OutSource, Category.Enterprise].includes(category):
			  return [ViewSelect, Add, Edit, Delete];
			  // 目录授权
			case CategoryDir.includes(category):
			  Add.label = "写入"
			  return [ViewSelect, Add, Delete];
			  // 其他
			default:
			  return [ViewSelect, Download, Add, Edit,  Delete];
		  }
		}
	}

	// 获取已授权列表
	static getAuthList(categoryId: number, dataId: number) {
		return DataService.get(`${ApiService.JrzzApi}/power/${categoryId}/list`, {dataId}).then(res => {
		  let list: any = [];
		  res.forEach((item: any) => {
			// 加入资源库保存，会有字段没有；
			if (categoryId != 105) item.Power.view = item.Power.view > -1 ? item.Power.view : "";
			item.Name = item.BeUserID ? item.BeUserName : item.BeOrgName || item.BeCompName;
			item.ExpiryDate = UtilLibs.DateFormat(item.ExpiryDate);
			item.IsDelete = false;
			item.CompID = item.BeCompID;
			item.OrgID = item.BeOrgID;
			item.UserID = item.BeUserID;
			item.view = item.Power.view > -1 ? rangeEnum[item.Power.view] : "未设置" // authView页面展示用；
			list.push(item);
		  });
		  return list;
		});
	}

	// 保存授权
	static saveAuth(params: any) {
		return DataService.post(`${ApiService.JrzzApi}/power/save`, params);
	}

	// 获取子公司 目录
	static async getSubComps(compId: Number,page:number=1,pageSize:number=999) {
		let res = await DataService.get(`${ApiService.JrzzApi}/comp/GetComposeComps?page=${page}&pageSize=${pageSize}&compId=${compId}`);
		let list = res.List.map((item: any) => {
		  return {
			Name: item.CompName || "",
			CompName: item.CompName,
			CompID: item.CompID,
			OrgID: 0,
			UserID: 0,
			isLeaf: true,
		  }
		});
		return list;
	}

	// 获取集团 目录
	static async getGroupComps(compId: Number) {
		let res = await DataService.get(`${ApiService.JrzzApi}/comp/GetCompGroup?compId=${compId}`);
		let list = res.map((item: any) => {
		  return {
			Name: item.CompName || "",
			CompName: item.CompName,
			CompID: item.CompID,
			OrgID: 0,
			UserID: 0,
			isLeaf: true,
		  }
		});
		return list;
	}

	// 获取部门下的人员
	static async getOrgUsers(pid: any, compId: Number) {
		const res = await DataService.get(`${ApiService.JrzzApi}/org/stafflist?compId=${compId}&orgId=${pid}&layer=0&page=1&pageSize=999999`);
		let users = res.List.map((item: any) => {
		  item.Name = item.UserName || "";
		  item.CompName = this.user().CompName;
		  item.CompID = compId;
		  item.isLeaf = true;
		  return item;
		})
		return users
	}

	// 获取org和组织下的人员
	static async getOrgs(pid: any, compId: Number) {
		if (!OrgList) {
		  OrgList = await DataService.get(`${ApiService.JrzzApi}/org/list?compId=${compId}`);
		}
		const res = OrgList.filter((item: any) => item.ParentID == pid).map((item: any) => {
		  item.Name = item.OrgName;
		  item.CompName = this.user().CompName;
		  item.CompID = compId;
		  item.UserID = 0;
		  item.isLeaf = false;
		  return item
		});
		const orgUsers = await AuthService.getOrgUsers(pid, compId);
		res.push(...orgUsers);
		return res;
	}
}
